import { useEffect, useState } from "react";
import HelpWindow from "../HelpWindow/HelpWindow";

const NegativePrompt = ({ style, dictionary, changeSettings, isLoading, defaultValue }) => {
	const [value, setValue] = useState(defaultValue || "");

	useEffect(() => setValue(defaultValue || ""), [defaultValue]);

	const changeValue = ({ target }) => {
		const newValue = target.value;
		setValue(newValue);
		changeSettings(newValue, "negative_prompt");
	};

	return (
		<div className={`${style["settings-default-item"]} ${style["line"]}`}>
			<p className={style[`title`]}>
				{dictionary["negative_prompt"] || "Negative prompt"} <HelpWindow dictionary={dictionary} name={"negative"} />
			</p>
			<input id="negative-input" disabled={isLoading} type="text" value={value} onChange={changeValue} placeholder={dictionary["eg_low_quality"] || 'Eg. "Low quality"'} />
		</div>
	);
};

export default NegativePrompt;
